import type { FC } from "react";
import type { CategoryEventListViewModel } from "src/http/api-types";
import { TOP_LEVEL_CATEGORY } from "src/website-apps/shared/constants/TopLevelCategory";
import { useLocationChange } from "src/website-apps/shared/hooks/useLocationChange";
import { ImmersiveLayoutBody } from "./ImmersiveLayoutBody";
import { LayoutBody } from "./LayoutBody";

interface Props {
  model: CategoryEventListViewModel;
}

/**
 * Manages Returning Appropriate Immersive Layouts for Subcategories Per TLC
 */
export const LayoutBodyManager: FC<Props> = ({ model }) => {
  const { onLocationChange, location } = useLocationChange();

  if (model.tlcId === TOP_LEVEL_CATEGORY.SPORT && model.isImmersivePage) {
    return <ImmersiveLayoutBody location={location} model={model} setLocation={onLocationChange} />;
  }

  return <LayoutBody model={model} />;
};
